import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../shared/services/validation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CardValidationModel } from '../../../model/card.validation.model';
import { Card } from '../../../model/card';
import { CreditCard } from '../../../model/credit.card';
import { CreditCardValidators } from 'angular-cc-library';
import { ExpirationDateUtil } from '../../../model/util/expiration-date-util';
import { TextService } from '../../../shared/services/text.service';
import { SessionService } from '../../../shared/services/session.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { KartDogrulama } from "../../../model/netmera-events/kart-dogrulama";
import { Error } from "../../../model/netmera-events/error";

@Component({
  selector: 'pa-signup-card',
  templateUrl: './signup-card.component.html',
  styleUrls: ['./signup-card.component.scss']
})
export class SignupCardComponent implements OnInit {
  model: CardValidationModel;
  selectedCard: Card;
  card: CreditCard = new CreditCard();
  errorMessage: string;
  textService: TextService;
  trackingId: string;
  merchantCode: string;
  sdkInitTexts: Array<SdkInitText>;

  cardFormGroup = new FormGroup({
    cards: new FormArray([]),
    expirationDate: new FormControl(''),
    cardBrand: new FormControl('')
  });

  constructor(private router: Router, private route: ActivatedRoute, private sessionService:SessionService, private validationService: ValidationService,
              textService: TextService, private netmeraService: NetmeraService, private kartDogrulama: KartDogrulama, private error: Error) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        this.sdkInitTexts = response.sdkInitTexts;
        this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
        this.netmeraService.pushEvent(this.kartDogrulama.setEventObject("KartDogrulamaEkrani", this.merchantCode));
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    });
    this.getCardValidationModel();
  }

  get cards() {
    return this.cardFormGroup.get('cards') as FormArray;
  }

  getCardValidationModel() {
    this.validationService.getCardValidationModel(this.trackingId).subscribe(
      response => {
        if (response != null && response.cardList != null) {
          this.model = response;
          for (const card of response.cardList) {
            this.cards.push(new FormControl(card));
          }
        }
      },
      error => {
        this.router.navigate(['/result/error', this.trackingId]);
      }
    );
  }

  setSelectedCard(card: Card) {
    this.selectedCard = card;
    this.cardFormGroup.get("expirationDate").setValue(null);
    this.cardFormGroup.get("cardBrand").setValue(null);
    this.isPayeCard();
  }

  checkSkt() {
    if (this.selectedCard == null) {
      return;
    }
    if (this.cardFormGroup.invalid) {
      return;
    }
    this.card.name = this.selectedCard.cardId
    this.card.cardNumber = this.selectedCard.cardNumber;
    this.card.cardType = this.selectedCard.cardBrand;
    this.card.month = parseInt(ExpirationDateUtil.takeMonthFromExpirationDate(this.cardFormGroup.value.expirationDate));
    this.card.year = parseInt(ExpirationDateUtil.takeYearFromExpirationDate(this.cardFormGroup.value.expirationDate));
    this.validationService.checkSkt(this.card, this.trackingId).subscribe(
      response => {
        this.netmeraService.pushEvent(this.kartDogrulama.setEventObject("KartDogrulamaBasarili", this.merchantCode));
        this.router.navigate(['/route', this.trackingId]);
      },
      error => {
        this.netmeraService.pushEvent(this.kartDogrulama.setEventObject("KartDogrulamaBasarisiz", this.merchantCode));
        this.netmeraService.pushEvent(this.error.setEventObject("KartDogrulamaBasarisiz", this.merchantCode));
        if (error.error.message === "3026" || error.error.message === "3025") {
          this.errorMessage = error.error.consoleMessage;
        } else {
          this.router.navigate(['/result/error', this.trackingId]);
        }
      }
    );
  }

  cancelAccount() {
    this.validationService.cancelAccount(this.trackingId).subscribe(
      () => {
        this.netmeraService.pushEvent(this.kartDogrulama.setEventObject("CancelAccountBasarili", this.merchantCode));
        this.router.navigate(['/route', this.trackingId]);
      },
      error => {
        this.netmeraService.pushEvent(this.kartDogrulama.setEventObject("CancelAccountBasarisiz", this.merchantCode));
        this.netmeraService.pushEvent(this.error.setEventObject("CancelAccountBasarisiz", this.merchantCode));
        this.router.navigate(['/result/error', this.trackingId]);
      }
    );
  }

  isBtnDisabled() {
    if (this.selectedCard == null || this.selectedCard.cardBrand === 'PAYE') {
      return true;
    }
    return ((this.cardFormGroup.controls.expirationDate.errors && this.cardFormGroup.controls.expirationDate.errors.required) || (this.cardFormGroup.controls.expirationDate.errors && this.cardFormGroup.controls.expirationDate.errors.expDate));
  }

  isPayeCard() {
    if (this.selectedCard.cardBrand === 'PAYE') {
      this.cardFormGroup.controls['cardBrand'].setValidators([Validators.required, Validators.minLength(5)]);
      this.cardFormGroup.controls['expirationDate'].clearValidators();
    } else {
      this.cardFormGroup.controls['expirationDate'].setValidators([Validators.required, CreditCardValidators.validateExpDate]);
      this.cardFormGroup.controls['cardBrand'].clearValidators();
    }
    this.cardFormGroup.controls['cardBrand'].updateValueAndValidity();
    this.cardFormGroup.controls['expirationDate'].updateValueAndValidity();
  }

  messageState(value: any) {
    this.errorMessage = value;
  }

}
